export enum Course {
    Intensive = "Intensive", 
    SemiIntensive = "Semi-Intensive",
    Relaxed= "Relaxed"
}